export enum CallDetailTab {
    SUMMARY = 'summary',
    PHOTOS = 'photos',
    CALL_DETAILS = 'call_details',
}
